import { render } from "./AddNewAirConditioner.vue?vue&type=template&id=5689b7c2"
import script from "./AddNewAirConditioner.vue?vue&type=script&lang=js"
export * from "./AddNewAirConditioner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__